/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HorecaReceptionBellIcon24Solid = forwardRef('HorecaReceptionBellIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M13 1a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V1Z" }),
        React.createElement("path", { d: "M17.893 2.293a1 1 0 1 1 1.414 1.414l-1.3 1.3a1 1 0 1 1-1.414-1.414l1.3-1.3Z" }),
        React.createElement("path", { d: "M11 8v1.562a8.006 8.006 0 0 0-6.85 6.383c-.11.566.352 1.055.929 1.055H18.92c.577 0 1.04-.489.928-1.055A8.006 8.006 0 0 0 13 9.563V8h1.4a1 1 0 1 0 0-2H9.6a1 1 0 0 0 0 2H11Z" }),
        React.createElement("path", { d: "M1.5 20a2 2 0 0 1 2-2h17a2 2 0 1 1 0 4h-17a2 2 0 0 1-2-2Z" }),
        React.createElement("path", { d: "M20 9h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M4.693 2.293a1 1 0 0 1 1.414 0l1.3 1.3a1 1 0 1 1-1.414 1.414l-1.3-1.3a1 1 0 0 1 0-1.414Z" }),
        React.createElement("path", { d: "M2 7a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2H2Z" })));
});
